import { ref } from 'vue';
import { format } from 'date-fns';
import { enUS, ru } from 'date-fns/locale';

// Each app bundle has its own locale; reading this ref also makes dates react
// to language changes without exposing widget state to the dashboard.
const currentLocale = ref('en');

export const setDateLocale = locale => {
  currentLocale.value = locale;
};

export const getDateLocale = () =>
  /^ru(?:[-_]|$)/i.test(currentLocale.value) ? ru : enUS;

const russianFormats = {
  MMM: 'LLL',
  MMMM: 'LLLL',
  'h:mm a': 'HH:mm',
  'h.mmaaa': 'HH:mm',
  'd MMM yyyy, h.mmaaa': 'd MMM yyyy, HH:mm',
  'd MMM, h.mmaaa': 'd MMM, HH:mm',
  'EEE, d MMM, h:mm a': 'EEE, d MMM, HH:mm',
  'EEE, d MMM yyyy, h:mm a': 'EEE, d MMM yyyy, HH:mm',
  'hh:mma': 'HH:mm',
  'hh:mm a': 'HH:mm',
  'MMMM d, yyyy': 'd MMMM yyyy',
  'MMM dd, yyyy, hh:mm a': 'd MMM yyyy, HH:mm',
  'MMM d, yyyy h:mm a': 'd MMM yyyy, HH:mm',
  'MMM dd, yyyy hh:mm a': 'd MMM yyyy, HH:mm',
  'LLL d, yyyy hh:mm a': 'd MMM yyyy, HH:mm',
  'dd MMM yyyy, h:mm a': 'd MMM yyyy, HH:mm',
  'MMM d': 'd MMM',
  'LLL d': 'd MMM',
  'MMM d, yyyy': 'd MMM yyyy',
  'MMM dd, yyyy': 'd MMM yyyy',
  'LLL d, yyyy': 'd MMM yyyy',
  'LLL d, h:mm a': 'd MMM, HH:mm',
  'LLL d yyyy, h:mm a': 'd MMM yyyy, HH:mm',
  'LLL d y, h:mm a': 'd MMM yyyy, HH:mm',
};

export const getDatePickerLanguage = () => {
  const locale = getDateLocale();
  const labels = (count, unit, width) =>
    Array.from({ length: count }, (_, index) =>
      locale.localize[unit](index, { width })
    );
  return {
    formatLocale: {
      months: labels(12, 'month', 'wide'),
      monthsShort: labels(12, 'month', 'abbreviated'),
      weekdays: labels(7, 'day', 'wide'),
      weekdaysShort: labels(7, 'day', 'abbreviated'),
      weekdaysMin: labels(7, 'day', 'short'),
      firstDayOfWeek: locale.options.weekStartsOn,
      firstWeekContainsDate: locale.options.firstWeekContainsDate,
    },
    yearFormat: 'YYYY',
    monthFormat: 'MMMM',
  };
};

export const formatLocalizedDate = (date, dateFormat) => {
  const locale = getDateLocale();
  const pattern =
    locale === ru ? russianFormats[dateFormat] || dateFormat : dateFormat;
  return format(date, pattern, { locale });
};
